// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-counter {
    display: flex;
    width: 100%;
    height: 56px;
    margin-bottom: 10px;
}
.lr-count {
    cursor: default;
    border: solid 1px #6e6e6e;
    border-left: none;
    border-right: none;
    text-align: center;
    width: calc(100% - 112px);
    color: #000000;
    font-size: 25px;
    font-weight: normal;
}
.lr-count:hover {
    border: solid 2px #6e6e6e;
    border-left-width: 1px;
    border-right-width: 1px;
}
.lr-count:active {
    border: solid 2px #003a65;
    border-left-width: 1px;
    border-right-width: 1px;
}
.lr-count:focus {
    border: solid 2px #0a70bc;
    border-left-width: 1px;
    border-right-width: 1px;
}
.lr-count-btn {
    width: 62px;
    display: flex;
    justify-content: center;
    padding: 1px;
    align-items: center;
    border: solid 1px #6e6e6e;
    background-color: #fff;
}
.lr-count-btn:hover {
    border: solid 2px #6e6e6e;
}
.lr-count-btn:active {
    border: solid 2px #003a65;
}
.lr-count-btn:focus {
    border: solid 2px #0a70bc;
}
.lr-count-btn:disabled {
    background-color: #f3f3f3;
}
.lr-count-btn:disabled:hover {
    border-width: 1px;
}
.olr-icon-plus-gray{
    background-image: url('icon-plus-gray.svg');
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    display: -webkit-inline-box;
}
.olr-icon-minus-gray{
    background-image: url('icon-minus-gray.svg');
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    display: -webkit-inline-box;
}`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/button-counter/button-counter.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,2CAA6D;IAC7D,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,4CAA8D;IAC9D,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B","sourcesContent":[".lr-counter {\n    display: flex;\n    width: 100%;\n    height: 56px;\n    margin-bottom: 10px;\n}\n.lr-count {\n    cursor: default;\n    border: solid 1px #6e6e6e;\n    border-left: none;\n    border-right: none;\n    text-align: center;\n    width: calc(100% - 112px);\n    color: #000000;\n    font-size: 25px;\n    font-weight: normal;\n}\n.lr-count:hover {\n    border: solid 2px #6e6e6e;\n    border-left-width: 1px;\n    border-right-width: 1px;\n}\n.lr-count:active {\n    border: solid 2px #003a65;\n    border-left-width: 1px;\n    border-right-width: 1px;\n}\n.lr-count:focus {\n    border: solid 2px #0a70bc;\n    border-left-width: 1px;\n    border-right-width: 1px;\n}\n.lr-count-btn {\n    width: 62px;\n    display: flex;\n    justify-content: center;\n    padding: 1px;\n    align-items: center;\n    border: solid 1px #6e6e6e;\n    background-color: #fff;\n}\n.lr-count-btn:hover {\n    border: solid 2px #6e6e6e;\n}\n.lr-count-btn:active {\n    border: solid 2px #003a65;\n}\n.lr-count-btn:focus {\n    border: solid 2px #0a70bc;\n}\n.lr-count-btn:disabled {\n    background-color: #f3f3f3;\n}\n.lr-count-btn:disabled:hover {\n    border-width: 1px;\n}\n.olr-icon-plus-gray{\n    background-image: url(../../../assets/img/icon-plus-gray.svg);\n    width: 20px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: -webkit-inline-box;\n}\n.olr-icon-minus-gray{\n    background-image: url(../../../assets/img/icon-minus-gray.svg);\n    width: 20px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: -webkit-inline-box;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
